import { Component, OnInit } from '@angular/core';

import Swal from 'sweetalert2';
import { Router } from '@angular/router';
import { JsonPipe } from '@angular/common';
import { FormBuilder, FormGroup, Validators, FormControl } from '@angular/forms';
import { DashboardService } from '../service/dashboard.service';
import { debounceTime, tap, switchMap, finalize } from 'rxjs/operators';
import { Observable } from 'rxjs';


interface companyData {
  agent_code: number;
  agent_family_name: string;
  phone: string;
  agent_pin_set: string;
  email: string;
  agent_type: string;
  agent_date_created: string;
  agent_date_modified: string;
}


@Component({
  selector: 'app-add-broker-admin',
  templateUrl: './add-broker-admin.component.html',
  styleUrls: ['./add-broker-admin.component.scss']
})




export class AddBrokerAdminComponent implements OnInit {


  errors = {}
  isBrokerCompanyLoading: boolean = false;
  currentUser;

  //broker company
  loadedBrokerCompany: companyData[];
  filteredBrokerCompany: companyData[];


  requestPayloadLogin = {
    email: '',
    role: 'admin'
  }


  requestPayload = {
    broker_admin_main_code: 0,
    broker_admin_main_name :'',
    broker_admin_email: '',
    broker_admin_phone: '',
    broker_admin_first_name: '',
    broker_admin_last_name: '',
    broker_admin_created_by: '',
    broker_admin_office: '',
    broker_company_name: ''
  }


  selectedBrokerMain: companyData = {
    agent_code: 0,
    agent_family_name: "",
    phone: "",
    agent_pin_set: "",
    email: "",
    agent_type: "",
    agent_date_created: "",
    agent_date_modified: ""
  }




  


  addBrokerForm: FormGroup;
  broker_company_name = new FormControl();
  brokerCode: number;
  brokerCompanyName: string = "";


  constructor(  public formBuilder: FormBuilder,
    public service: DashboardService,
    private router: Router) { }

  ngOnInit() {


    this.currentUser = JSON.parse(localStorage.getItem('userdata'))

    this.initializeAddBrokerForm()

    //Load companies
    this.onLoadBrokerCompany()

    //on companies Filter
    this.onFilterBrokerCompany()
  }




  initializeAddBrokerForm() {
    this.addBrokerForm = this.formBuilder.group({
      //broker_user_main_broker_code: this.requestPayload.broker_user_main_broker_code,
      broker_admin_email: new FormControl('', [Validators.required]),
      broker_admin_phone: new FormControl('', [Validators.required]),
      broker_admin_first_name: new FormControl('', [Validators.required]),
      broker_admin_last_name: new FormControl('', [Validators.required]),
      broker_admin_office: new FormControl(''),
      // broker_company_name: new FormControl('', [Validators.required]),
    });
  
  }
  
  
  postBroker() {
  
    if (this.addBrokerForm.valid && this.brokerCode) {
      this.requestPayload = this.addBrokerForm.value;
      this.requestPayload.broker_admin_created_by = this.currentUser.email;
  
      this.requestPayload.broker_admin_main_code = this.brokerCode
      this.requestPayload.broker_company_name = this.brokerCompanyName
      this.requestPayload.broker_admin_main_name = this.brokerCompanyName

  
  
     // console.log("requestPayload:  " + JSON.stringify(this.requestPayload));
  
      Swal.showLoading();
      this.service.addBrokerAdmin(this.requestPayload)
        .subscribe(response => {
       //   console.log(response);
  
          Swal.close();
          if (response['responseCode'] === '000') {
            this.initializeAddBrokerForm();
            this.brokerCode = 0
            this.brokerCompanyName = "";
  
            (Swal as any).fire({
              icon: 'success',
              title: 'Successful',
              text: 'Broker Admin account created successfully.',
            });
  
            this.router.navigate(['/add-broker-admin'])
  
          } else {
            (Swal as any).fire({
              icon: 'warning',
              title: 'Oops...',
              text: response['responseMessage'],
              footer: ''
            });
          }
  
        }, error => {
          (Swal as any).fire({
            icon: 'error',
            title: 'Oops...',
            text: JSON.stringify(error.error),
            footer: ''
          });
          Swal.close();
        })
  
  
    } else {
      (Swal as any).fire({
        icon: 'warning',
        title: 'Oops...',
        text: 'Please fill all form fields',
        footer: ''
      });
  
    }
  
  }
  
  
  
  
  
    //autocomplete search make
    onLoadBrokerCompany() {
      this.filteredBrokerCompany = [];
      this.loadedBrokerCompany = [];
  
      this.requestPayloadLogin.email = this.currentUser.email;
      this.requestPayloadLogin.role = this.currentUser.role;
     // console.log("requestPayloadLogin>>>> " + JSON.stringify(this.requestPayloadLogin));
  
      this.service.getBrokerMainAdmin(this.requestPayloadLogin)
        .toPromise()
        .then((response: any) => {
          if (response.hasOwnProperty('responseCode') && response.responseCode == '000') {
      //      console.log("companyData>>>> " + JSON.stringify(response.responseData))
  
            response.responseData.map((response: companyData) => {
              let company: companyData = { ...response, agent_family_name: `${response.agent_family_name}` };
              this.loadedBrokerCompany.push(company);
              this.filteredBrokerCompany.push(company);
            })
          }
        });
  
    }
  
    onFilterBrokerCompany() {
      this.broker_company_name.valueChanges
        .pipe(
          debounceTime(0),
          tap(() => {
            this.filteredBrokerCompany = [];
            this.isBrokerCompanyLoading = true;
          }),
          switchMap(value => {
            if (value.length) {
              return Observable.create(observer => {
                let payload = this.loadedBrokerCompany.filter((response: companyData) => response.agent_family_name.trim().toLowerCase().includes(value.trim().toLowerCase()) == true)
                observer.next(payload)
              })
                .pipe(
                  finalize(() => {
                    this.isBrokerCompanyLoading = false
                  }),
                )
            }
            else {
              this.isBrokerCompanyLoading = false
              return new Observable<[]>();
            }
          }
          )
        )
        .subscribe((models: any) => {
          if (models)
            models.map((response: companyData) => {
  
              this.filteredBrokerCompany.push({ ...response, agent_family_name: `${response.agent_family_name}` });
            })
        })
    }
  
  
    //company change event
    onBrokerCompanyChange(event) {
      if (!event.target.value) {
  
        this.selectedBrokerMain = {
          agent_code: 0,
          agent_family_name: "",
          phone: "",
          agent_pin_set: "",
          email: "",
          agent_type: "",
          agent_date_created: "",
          agent_date_modified: ""
        }
  
        this.requestPayload.broker_admin_main_code = this.selectedBrokerMain.agent_code
  
      } else {
        //this.filteredModels=[];
      }
  
    }
  

    onSelectBrokerAdmin(data: companyData) {
      // console.log('make selected', make)
       this.errors = { ...this.errors, data: false };
   
       this.selectedBrokerMain = data;
       this.brokerCode = this.selectedBrokerMain.agent_code
       this.brokerCompanyName = this.selectedBrokerMain.agent_family_name
   
     }
   
  
    addBroker() {
      this.router.navigate(['/add-broker-main'])
    }
  
  
    brokers() {
      this.router.navigate(['/broker-admin'])
    }

}
